module.exports = __webpack_public_path__ + "static/media/yunhaojingpin.7e42f5f5.png";